import { __rest } from "tslib";
import { api, apiHolder, apis, ReminderAction, } from 'api';
import omit from 'lodash/omit';
import { EnumRange, InviteType, ScheduleSendMailEnum } from './data';
import { getDateTime, getDateTimeByFormWithZone } from './util';
import { EnmuRecurrenceRule, SCHEDULE_REMINDER_ACTION, getInsertRecurrenceRule } from './components/CreateBox/util';
import { getIn18Text } from 'api';
const storeApi = api.getDataStoreApi();
const catalogApi = apiHolder.api.requireLogicalApi(apis.catalogApiImpl);
const filterSelfCatalog = (list) => list.filter(e => e.isOwner);
export const getCatalogList = async (mine = false, cached = true) => {
    const res = await catalogApi.doGetCatalogByItem(undefined, cached);
    if (mine) {
        return filterSelfCatalog(res);
    }
    return res;
};
export const getEvents = async (option, cached = true, needCompare) => {
    const { catalogIds, start, end } = option;
    if (!catalogIds) {
        return [];
    }
    const ids = catalogIds.filter(i => !!i);
    if (ids && ids.length === 0) {
        return [];
    }
    let res = [];
    try {
        res = await catalogApi.doGetScheduleByDate(ids, getDateTime(start), getDateTime(end), cached, needCompare);
    }
    catch (error) {
        throw new Error(getIn18Text('TONGBURICHENGCHU'));
    }
    return res;
};
export const syncPreNextEventsToDB = async (option, _cached = true, _needCompare = false) => {
    const { catalogIds, start, end } = option;
    const startTime = moment(start);
    const endTime = moment(end);
    startTime.subtract(6, 'week');
    endTime.add(6, 'week');
    let res = [];
    if (!catalogIds) {
        return [];
    }
    const ids = catalogIds.filter(i => !!i);
    if (ids && ids.length === 0) {
        return [];
    }
    try {
        const promises = await Promise.allSettled([
            catalogApi.doGetScheduleByDate(ids, getDateTime(startTime.toDate()), getDateTime(start), true, true, false),
            catalogApi.doGetScheduleByDate(ids, getDateTime(end), getDateTime(endTime.toDate()), true, true, false),
        ]);
        promises.forEach(prmsRes => {
            if (prmsRes.status === 'fulfilled') {
                res = res.concat([...prmsRes.value]);
            }
        });
    }
    catch (error) {
        throw new Error(getIn18Text('TONGBURICHENGCHU'));
    }
    return res;
};
export const getEventDetail = async (item) => {
    const res = await catalogApi.doGetScheduleDetail(item.scheduleInfo.catalogId, item.scheduleInfo.recurrenceId, item.scheduleInfo.scheduleId);
    res[0].scheduleInfo.description = res[0].scheduleInfo.description === '<p></p>' ? '' : res[0].scheduleInfo.description;
    return res;
};
export const getEventDetailByUid = async (uid) => {
    const res = await catalogApi.doGetScheduleDetailByUid(uid);
    res[0].scheduleInfo.description = res[0].scheduleInfo.description === '<p></p>' ? '' : res[0].scheduleInfo.description;
    return res;
};
export const getMeetingRoomReserveConfig = async () => {
    const res = await catalogApi.doGetMeetingRoomReserveConfig();
    return res;
};
export const cancelScheduleMeetingRoom = async (eventDetail) => {
    var _a, _b, _c, _d, _e, _f;
    const scheduleInfo = eventDetail.scheduleInfo;
    const meetingInfo = scheduleInfo.meetingInfo;
    const zoneId = ((_b = (_a = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.time) === null || _a === void 0 ? void 0 : _a.startZone) === null || _b === void 0 ? void 0 : _b.id) || ((_d = (_c = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.time) === null || _c === void 0 ? void 0 : _c.endZone) === null || _d === void 0 ? void 0 : _d.id);
    const required = eventDetail.contactInfo.filter(item => !item.isOrganizer).map(item => item.email);
    const insert = {
        required,
        optional: [],
        moreInvitee: [],
        attachments: scheduleInfo.attachments,
        senderMail: ScheduleSendMailEnum.NOT_SEND,
        time: Object.assign(Object.assign({}, scheduleInfo.time), { endZoneId: zoneId, startZoneId: zoneId }),
        reminders: scheduleInfo.reminders,
        description: scheduleInfo.description,
        summary: scheduleInfo.summary,
        transp: scheduleInfo.transp,
        catalogId: eventDetail.catalogInfo.catalogId,
        color: scheduleInfo.color,
        location: '',
        clazz: scheduleInfo.clazz,
        meetingOrderParam: {
            taken_date: meetingInfo.date,
            room_id: meetingInfo.room_id,
            order_id: meetingInfo.order_id,
            update_type: 2,
        },
    };
    if ((_e = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.time) === null || _e === void 0 ? void 0 : _e.recur) {
        insert.time.recurrenceRule = Object.assign({}, (_f = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.time) === null || _f === void 0 ? void 0 : _f.recur);
    }
    return catalogApi.doUpdateSchedule({
        range: EnumRange.THIS,
        catalogId: eventDetail.catalogInfo.catalogId,
        scheduleId: scheduleInfo.scheduleId,
        recurrenceId: scheduleInfo.recurrenceId,
        isOrganizer: scheduleInfo.inviteeType === InviteType.ORGANIZER,
        param: Object.assign({}, insert),
    });
};
export const deleteEvent = async (item, range = EnumRange.THIS) => catalogApi.doDeleteSchedule({
    catalogId: item.scheduleInfo.catalogId,
    scheduleId: item.scheduleInfo.scheduleId,
    range,
    recurrenceId: item.scheduleInfo.recurrenceId,
    senderMail: ScheduleSendMailEnum.SEND,
    isOrganizer: item.scheduleInfo.inviteeType === InviteType.ORGANIZER,
});
export const addEvent = async (form, condition) => {
    const { moments: { startDate, endDate, startTime, endTime }, time: { allDay }, reminders, enmuRecurrenceRule, rruleUntil, attachments, count, includeIcs = 0, zoneId: _zoneId, } = form;
    let zoneId = _zoneId;
    if (!zoneId) {
        zoneId = await catalogApi.getZoneId();
    }
    const zoneList = await catalogApi.getZoneList();
    const attachmentsCp = (attachments &&
        attachments.map(f => {
            var _a;
            return ({
                accountAttachmentId: f.accountAttachmentId,
                accountAttachmentAccountId: f.accountAttachmentAccountId || ((_a = f.belonger) === null || _a === void 0 ? void 0 : _a.accountId),
            });
        })) ||
        [];
    const insert = {
        optional: form.optional || [],
        attachments: attachmentsCp,
        senderMail: (condition === null || condition === void 0 ? void 0 : condition.get('senderMail')) || ScheduleSendMailEnum.NOT_SEND,
        required: form.required,
        catalogId: form.catalogId,
        summary: form.summary,
        location: form.location,
        clazz: form.clazz,
        transp: form.transp,
        description: form.description,
        color: form.color,
        uid: form.uid,
        meetingOrderParam: form.meetingOrderParam,
        reminders,
        time: {
            allDay: allDay ? 1 : 0,
            start: getDateTimeByFormWithZone(startDate, startTime, !!allDay, zoneId, zoneList),
            end: getDateTimeByFormWithZone(allDay ? endDate.clone().add(1, 'days') : endDate, endTime, !!allDay, zoneId, zoneList),
            endZoneId: zoneId,
            startZoneId: zoneId,
        },
        moreInvitee: [],
        includeIcs,
    };
    if (enmuRecurrenceRule !== undefined && enmuRecurrenceRule !== EnmuRecurrenceRule.NONE) {
        insert.time.recurrenceRule = getInsertRecurrenceRule(form, !!(condition === null || condition === void 0 ? void 0 : condition.get('autoPrev')));
        if (count) {
            insert.time.recurrenceRule.count = count;
        }
        else if (rruleUntil) {
            insert.time.recurrenceRule.until = getDateTime(rruleUntil.toDate());
        }
    }
    if ((reminders === null || reminders === void 0 ? void 0 : reminders.length) > 0) {
        const lastReminder = reminders[reminders.length - 1];
        storeApi.putSync(SCHEDULE_REMINDER_ACTION, String((lastReminder === null || lastReminder === void 0 ? void 0 : lastReminder.reminderAction) || ReminderAction.EMAIL_APP));
    }
    return catalogApi.doInsertSchedule(insert);
};
export const editEvent = async (form, item, condition = new Map()) => {
    var _a, _b, _c;
    const { enmuReminders, enmuRecurrenceRule, moments: { startDate, endDate, startTime, endTime }, time: { allDay }, rruleUntil, attachments, count, required, moreInvitee, reminders, zoneId: _zoneId } = form, rest = __rest(form, ["enmuReminders", "enmuRecurrenceRule", "moments", "time", "rruleUntil", "attachments", "count", "required", "moreInvitee", "reminders", "zoneId"]);
    let zoneId = _zoneId;
    if (!zoneId) {
        zoneId = await catalogApi.getZoneId();
    }
    const zoneList = await catalogApi.getZoneList();
    const isOrganizer = item.scheduleInfo.inviteeType === InviteType.ORGANIZER;
    const attachmentsCp = (attachments &&
        attachments.map(f => {
            var _a;
            return ({
                accountAttachmentId: f.accountAttachmentId,
                accountAttachmentAccountId: f.accountAttachmentAccountId || ((_a = f.belonger) === null || _a === void 0 ? void 0 : _a.accountId),
            });
        })) ||
        [];
    let mergedInvitees;
    if (moreInvitee && moreInvitee.length) {
        mergedInvitees = [...new Set([...required, ...moreInvitee])];
    }
    else {
        mergedInvitees = [...required];
    }
    const insert = Object.assign(Object.assign({}, rest), { required: mergedInvitees, attachments: attachmentsCp, optional: [], reminders, senderMail: condition.get('senderMail') || ScheduleSendMailEnum.NOT_SEND, time: {
            allDay: allDay ? 1 : 0,
            start: getDateTimeByFormWithZone(startDate, startTime, !!allDay, zoneId, zoneList),
            end: getDateTimeByFormWithZone(allDay ? endDate.clone().add(1, 'days') : endDate, endTime, !!allDay, zoneId, zoneList),
            endZoneId: zoneId,
            startZoneId: zoneId,
        } });
    if (enmuRecurrenceRule !== undefined && enmuRecurrenceRule !== EnmuRecurrenceRule.NONE) {
        if (isOrganizer) {
            const rrule = getInsertRecurrenceRule(form, !!(condition === null || condition === void 0 ? void 0 : condition.get('autoPrev'))) || Object.assign(Object.assign({}, omit(item.scheduleInfo.recur, 'recurIntro')), { freq: ((_a = item.scheduleInfo.recur) === null || _a === void 0 ? void 0 : _a.freq) || item.scheduleInfo.recur.frequency, userFreq: ((_b = item.scheduleInfo.recur) === null || _b === void 0 ? void 0 : _b.userFreq) || item.scheduleInfo.recur.userFrequency });
            if (rrule && (insert === null || insert === void 0 ? void 0 : insert.time)) {
                insert.time.recurrenceRule = rrule;
                if (count) {
                    insert.time.recurrenceRule.count = count;
                }
                else if (rruleUntil) {
                    insert.time.recurrenceRule.until = getDateTime(rruleUntil.toDate());
                }
            }
        }
        else if ((insert === null || insert === void 0 ? void 0 : insert.time) && ((_c = item === null || item === void 0 ? void 0 : item.scheduleInfo) === null || _c === void 0 ? void 0 : _c.recur)) {
            insert.time.recurrenceRule = Object.assign({}, item.scheduleInfo.recur);
        }
    }
    if ((reminders === null || reminders === void 0 ? void 0 : reminders.length) > 0) {
        const lastReminder = reminders[reminders.length - 1];
        storeApi.putSync(SCHEDULE_REMINDER_ACTION, String((lastReminder === null || lastReminder === void 0 ? void 0 : lastReminder.reminderAction) || ReminderAction.EMAIL_APP));
    }
    return catalogApi.doUpdateSchedule({
        range: condition.get('range') || EnumRange.THIS,
        catalogId: item.scheduleInfo.catalogId,
        scheduleId: item.scheduleInfo.scheduleId,
        recurrenceId: item.scheduleInfo.recurrenceId,
        isOrganizer,
        param: Object.assign({}, insert),
    });
};
export const addMoreInvitees = async (eventDetail, contact) => {
    var _a, _b, _c, _d, _e, _f;
    const scheduleInfo = eventDetail.scheduleInfo;
    const zoneId = ((_b = (_a = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.time) === null || _a === void 0 ? void 0 : _a.startZone) === null || _b === void 0 ? void 0 : _b.id) || ((_d = (_c = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.time) === null || _c === void 0 ? void 0 : _c.endZone) === null || _d === void 0 ? void 0 : _d.id);
    const user = eventDetail.scheduleInfo.organizer.extDesc;
    const mergedInvitees = new Set([...eventDetail.contactInfo.map(item => item.email), ...contact]);
    if (mergedInvitees.has(user)) {
        mergedInvitees.delete(user);
    }
    const insert = {
        required: [...mergedInvitees],
        moreInvitee: [...contact],
        attachments: scheduleInfo.attachments,
        optional: [],
        senderMail: ScheduleSendMailEnum.SEND,
        time: Object.assign(Object.assign({}, scheduleInfo.time), { endZoneId: zoneId, startZoneId: zoneId }),
        reminders: scheduleInfo.reminders,
        description: scheduleInfo.description,
        summary: scheduleInfo.summary,
        transp: scheduleInfo.transp,
        catalogId: eventDetail.catalogInfo.catalogId,
        color: scheduleInfo.color,
        location: scheduleInfo.location,
        clazz: scheduleInfo.clazz,
    };
    if ((_e = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.time) === null || _e === void 0 ? void 0 : _e.recur) {
        insert.time.recurrenceRule = Object.assign({}, (_f = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.time) === null || _f === void 0 ? void 0 : _f.recur);
    }
    return catalogApi.doUpdateSchedule({
        range: EnumRange.ALL,
        catalogId: eventDetail.catalogInfo.catalogId,
        scheduleId: scheduleInfo.scheduleId,
        recurrenceId: scheduleInfo.recurrenceId,
        isOrganizer: scheduleInfo.inviteeType === InviteType.ORGANIZER,
        param: Object.assign({}, insert),
    });
};
export const reactionEvent = async (t, item, range = EnumRange.ALL) => {
    const res = await catalogApi.doOperateSchedule({
        catalogId: item.scheduleInfo.catalogId,
        scheduleId: item.scheduleInfo.scheduleId,
        partStat: t,
        range,
        recurrenceId: item.scheduleInfo.recurrenceId,
    });
    setTimeout(() => {
        catalogApi.initScheduleNotice();
    }, 2000);
    return res;
};
export const unsubscribeCatalog = async (catalog) => {
    const success = await catalogApi.doUnsubscribeCatalog({
        accountId: catalog.belonger.accountId,
        catalogId: catalog.id,
    });
    return success;
};
export const getZoneId = async () => {
    const zoneId = await catalogApi.getZoneId();
    return zoneId;
};
export const delelteMyCatalog = async (catalog) => {
    const rs = await catalogApi.doDeleteMyCatalog({
        catalogId: catalog.id,
    });
    return rs;
};
export const unsubscribeCatalogFromSelfList = async (catalog) => {
    const success = await catalogApi.doDeleteCatalog({
        catalogId: catalog.id,
    });
    return success;
};
export const deleteThirdAccountCatalog = async (catalogArr) => {
    var _a, _b;
    const catalogIds = catalogArr.map(c => Number(c.id));
    const syncAccountId = Number(catalogArr[0].syncAccountId);
    const syncAccountType = Number((_b = (_a = catalogArr[0]) === null || _a === void 0 ? void 0 : _a.thirdAccount) === null || _b === void 0 ? void 0 : _b.syncAccountType);
    const success = await catalogApi.deleteThirdAccountCatalog({ catalogIds, syncAccountId, syncAccountType });
    return success;
};
export const getSetting = async () => {
    const res = await catalogApi.doGetSetting();
    return res;
};
export const getZoneList = async () => {
    const res = await catalogApi.getZoneList();
    return res;
};
export const updateSetting = async (params) => {
    const res = await catalogApi.doUpdateSettings(params);
    return res;
};
export const subscribeCatalog = async (catalog) => {
    const success = await catalogApi.doSubscribeCatalog({
        accountId: catalog.belonger.accountId,
        catalogId: catalog.id,
    });
    return success;
};
export const queryContactCatalog = async (email) => {
    const res = await catalogApi.doGetSubscribeCatalogByContact({
        owner: email,
    });
    return res;
};
export const getMeetingRoomOccupied = async (params) => {
    const occupied = await catalogApi.doGetMeetingRoomDetail(params);
    return occupied;
};
export const getMeetingRoomList = async (params, orderId) => {
    const roomList = await catalogApi.doGetMeetingRoomList(params);
    const fetchDetailPromises = roomList.map(room => {
        if (room.roomBookInfoVO.time_axis.some(stauts => stauts === 1)) {
            return new Promise(resovle => {
                getMeetingRoomOccupied({
                    room_id: room.room_id,
                    date: params.date,
                })
                    .then(detail_list => {
                    const occupy_list = detail_list.occupy_list.map((e, index) => {
                        if (e.order_id && e.order_id === orderId) {
                            room.roomBookInfoVO.time_axis[index] = 0;
                            return Object.assign(Object.assign({}, e), { status: 0 });
                        }
                        return e;
                    });
                    resovle(Object.assign(Object.assign({}, room), { occupy_list }));
                })
                    .catch(() => {
                    resovle(Object.assign({}, room));
                });
            });
        }
        return Object.assign({}, room);
    });
    const res = await Promise.all(fetchDetailPromises);
    return res;
};
export const getMeetingRoomAvailabelList = async (params) => {
    const res = await catalogApi.doGetAvailableRoom(params);
    const formatRes = res.map(e => ({
        roomInfo: e,
    }));
    return formatRes;
};
export const getOneMeetingRoomInfo = async (params) => {
    const param = Object.assign(Object.assign({}, params), { orderId: params.order_id });
    const res = await catalogApi.doGetOneRoomInfo(param);
    return res;
};
export const checkMeettingRoomExsit = async () => {
    const exsit = await catalogApi.doGetHasMeetingRoom();
    return exsit;
};
export const getMeetingRoomSearchCondition = async () => {
    const conditions = await catalogApi.doGetMeetingRoomCondition();
    return conditions;
};
export const getCatalogUnChecked = () => {
    const data = storeApi.getSync('CATALOG_UNCHEDCKED_ID');
    if (data.data === undefined) {
        return [];
    }
    try {
        const res = JSON.parse(data.data);
        if (Array.isArray(res)) {
            return res;
        }
        return [];
    }
    catch (error) {
        return [];
    }
};
export const saveCatalogUnChecked = async (ids) => {
    const data = await storeApi.put('CATALOG_UNCHEDCKED_ID', JSON.stringify(ids));
    return data;
};
export const actionCatalog = (key, afterClose) => {
    catalogApi.doActionCatalog(key, afterClose);
};
export const actionSetting = (afterClose, calendarId) => {
    catalogApi.doActionCatalog('config', afterClose, calendarId);
};
const filterCurrent = (list, uid) => {
    if (!uid) {
        return list;
    }
    return list.map(fb => {
        if (uid) {
            return Object.assign(Object.assign({}, fb), { freeBusyItems: fb.freeBusyItems.filter(it => it.uid !== uid) });
        }
        return fb;
    });
};
export const queryFreeBusyList = async (params) => {
    var _a;
    if (((_a = params === null || params === void 0 ? void 0 : params.users) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        return [];
    }
    if ((params === null || params === void 0 ? void 0 : params.start) === null || (params === null || params === void 0 ? void 0 : params.start) === undefined) {
        params.start = new Date();
    }
    if ((params === null || params === void 0 ? void 0 : params.end) === null || (params === null || params === void 0 ? void 0 : params.end) === undefined) {
        params.end = new Date();
    }
    const list = await catalogApi
        .doGetFreeBusyList({
        start: getDateTime(params.start),
        end: getDateTime(params.end),
        users: Array.from(params.users),
    })
        .then();
    return filterCurrent(list, params.uid);
};
export const getInitEvents = () => catalogApi.initData.schedule;
export const getAllPublicCatalog = async () => {
    const catalogList = await catalogApi.doGetAllPublicCatalog();
    return catalogList;
};
export const reminderSettingCatalog = async (params) => {
    const result = await catalogApi.doReminderSettingCatalog(params);
    setTimeout(() => {
        if (!!result) {
            catalogApi.initScheduleNotice();
        }
    }, 2000);
    return result;
};
